import React from 'react';
import {useSelector} from 'react-redux';
import '../style/userLayout.css';
import UserHeaderHOC from "../containers/userHeaderHOC";
import LayoutContent from "./layoutContent";
import LayoutFooterHOC from '../containers/General/layoutFooterHOC';
import {EnvironmentIndicator} from 'arag-ui-lib';
import useEnv from '../hooks/useEnv';
import { ENV_VARIABLES } from '../constants/configurationKeys';

const UserLayout = () => {

    const userRoles = useSelector((state) => state.user.loggedInUser.roles);
    const loggedInUserToba = useSelector((state) => state.user.loggedInUser.toba);
    const displayToba = useSelector((state) => state.user.displayToba);
    const envName = useEnv(ENV_VARIABLES.INDICATOR_NAME);
    const envCountry = useEnv(ENV_VARIABLES.INDICATOR_COUNTRY);

    return (
        <div className="container user-layout-wrapper-size">
            <UserHeaderHOC />
            <LayoutContent
                userRoles={userRoles}
                displayToba={displayToba}
                loggedInUserToba={loggedInUserToba}
            />
            <LayoutFooterHOC/>
            <EnvironmentIndicator
                country={envCountry || ''}
                envName={envName || ''}
            />
        </div>
    )
}

export default UserLayout;
